"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.optionsSortCompare = exports.getOptionDisplayName = exports.arrayOmit = exports.pick = void 0;
var pick = function (object, keys) {
    return keys.reduce(function (resultObject, key) {
        var _a;
        if (object && Object.prototype.hasOwnProperty.call(object, key)) {
            return __assign(__assign({}, resultObject), (_a = {}, _a[key] = object[key], _a));
        }
        return resultObject;
    }, {});
};
exports.pick = pick;
var arrayOmit = function (array, keys) {
    return array.filter(function (item) { return !keys.includes(item); });
};
exports.arrayOmit = arrayOmit;
var getOptionDisplayName = function (key, displayName, locale) {
    if (displayName && displayName[locale]) {
        return displayName[locale];
    }
    return key.replace(/-/g, ' ').replace(key[0], key[0].toUpperCase());
};
exports.getOptionDisplayName = getOptionDisplayName;
var optionsSortCompare = function (a, b) {
    if (a.key.toString() === 'other') {
        return 1;
    }
    if (b.key.toString() === 'other') {
        return -1;
    }
    return a.label.localeCompare(b.label);
};
exports.optionsSortCompare = optionsSortCompare;
